import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import DefaultButton from "../../../../../components/Buttons/Default";
import { post } from "../../../../../utils/helpers/api";
import { toast } from "react-toastify";

function CreateLeadSourceModal({ isOpen, toggle, refreshSettings, sourceToEdit }) {
  const { t } = useTranslation();
  const [saveLoading, setSaveLoading] = useState(false);
  const [sourceData, setSourceData] = useState({
    name: sourceToEdit?.name || null,
  });

  useEffect(() => {
    if(sourceToEdit) {
      setSourceData({
        name: sourceToEdit?.name || null,
      });
    } else {
      setSourceData({
        name: null,
      });
    }
  }, [sourceToEdit, isOpen]);

  const saveLeadSource = async () => {
    setSaveLoading(true);
    const url = sourceToEdit ? `/crm/settings/lead-sources/update/${sourceToEdit.id}` : '/crm/settings/lead-sources/store';
    const data = await post(url, sourceData)
    if(data?.success) {
      refreshSettings();
      toggle();
      toast.success(sourceToEdit ? t('alerts.success_update') : t('alerts.success_create'));
    } else {
      toast.error(data?.message || t('alerts.error'));
      toggle();
    }
    setSaveLoading(false);
  }

  return(
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader toggle={toggle}>{sourceToEdit ? t('crm.settings.lead_sources.edit') : t('crm.settings.lead_sources.create_new')}</ModalHeader>

      <ModalBody>
        <FormGroup>
          <Label>{t('common.name')}: </Label>
          <Input 
            value={sourceData?.name}
            onChange={e => setSourceData({...sourceData, name: e.target.value})}
          />
        </FormGroup>
      </ModalBody>

      <ModalFooter>
        <DefaultButton color="secondary" size="sm" outline onClick={toggle}>{t('common.cancel')}</DefaultButton>
        <DefaultButton 
          color="primary" 
          size="sm" 
          onClick={saveLeadSource}
          loading={saveLoading}
          disabled={saveLoading || !sourceData?.name}
        >{t('common.save')}</DefaultButton>
      </ModalFooter>
    </Modal>
  );
}

export default CreateLeadSourceModal;